export interface TerritoryRegion {
  name: string;
  provinces: {
    name: string;
    communes: string[];
  }[];
}

/**
 * Découpage territorial du Burkina Faso (régions, provinces, communes).
 * Utilisé par le formulaire « Ajouter un immeuble » pour la sélection en cascade.
 */
export const TERRITORY_REGIONS: TerritoryRegion[] = [
  {
    name: "Boucle du Mouhoun",
    provinces: [
      { name: "Mouhoun", communes: ["Dédougou", "Bondokuy", "Safané"] },
      { name: "Kossi", communes: ["Nouna", "Djibasso", "Barani"] },
      { name: "Sourou", communes: ["Tougan", "Di", "Lanfièra"] },
      { name: "Nayala", communes: ["Toma", "Yaba", "Gossina"] },
      { name: "Balé", communes: ["Boromo", "Bagassi", "Pâ"] },
      {
        name: "Banwa",
        communes: ["Solenzo", "Balavé", "Kouka", "Sami", "Sanaba", "Tansila"],
      },
    ],
  },
  {
    name: "Cascades",
    provinces: [
      { name: "Comoé", communes: ["Banfora", "Bérégadougou", "Mangodara"] },
      { name: "Léraba", communes: ["Sindou", "Douna", "Loumana"] },
    ],
  },
  {
    name: "Centre",
    provinces: [
      {
        name: "Kadiogo",
        communes: ["Ouagadougou", "Komki-Ipala", "Komsilga", "Koubri", "Pabré", "Tanghin-Dassouri"],
      },
    ],
  },
  {
    name: "Centre-Est",
    provinces: [
      { name: "Boulgou", communes: ["Tenkodogo", "Garango", "Bissiga", "Zabré"] },
      { name: "Kouritenga", communes: ["Koupéla", "Pouytenga", "Andemtenga"] },
      { name: "Koulpélogo", communes: ["Ouargaye", "Sangha", "Comin-Yanga"] },
    ],
  },
  {
    name: "Centre-Nord",
    provinces: [
      { name: "Bam", communes: ["Kongoussi", "Tikaré", "Zimtenga"] },
      { name: "Sanmatenga", communes: ["Kaya", "Barsalogho", "Pissila", "Boussouma"] },
      { name: "Namentenga", communes: ["Boulsa", "Bouroum", "Zéguédéguin"] },
    ],
  },
  {
    name: "Centre-Ouest",
    provinces: [
      { name: "Boulkiemdé", communes: ["Koudougou", "Sabou", "Kokologho"] },
      { name: "Sanguié", communes: ["Réo", "Kordié", "Tenado"] },
      { name: "Sissili", communes: ["Léo", "Nébiélianayou"] },
      { name: "Ziro", communes: ["Sapouy", "Bougnounou", "Cassou"] },
    ],
  },
  {
    name: "Centre-Sud",
    provinces: [
      { name: "Bazèga", communes: ["Kombissiri", "Kayao", "Doulougou"] },
      { name: "Nahouri", communes: ["Pô", "Guiaro", "Tiébélé"] },
      { name: "Zoundwéogo", communes: ["Manga", "Gogo", "Bindé"] },
    ],
  },
  {
    name: "Est",
    provinces: [
      { name: "Gourma", communes: ["Fada N'Gourma", "Diabo", "Diapangou"] },
      { name: "Tapoa", communes: ["Diapaga", "Tansarga", "Kantchari"] },
      { name: "Gnagna", communes: ["Bogandé", "Bilanga", "Coalla"] },
      { name: "Komondjari", communes: ["Gayéri", "Bartiébougou"] },
      { name: "Kompienga", communes: ["Pama", "Pama-Kantchari"] },
    ],
  },
  {
    name: "Hauts-Bassins",
    provinces: [
      { name: "Houet", communes: ["Bobo-Dioulasso", "Karangasso-Vigué", "Léna", "Bama"] },
      { name: "Kénédougou", communes: ["Orodara", "Samorogouan", "Kourinion"] },
      { name: "Tuy", communes: ["Houndé", "Béréba", "Koumbia"] },
    ],
  },
  {
    name: "Nord",
    provinces: [
      { name: "Yatenga", communes: ["Ouahigouya", "Séguénéga"] },
      { name: "Passoré", communes: ["Yako", "Bokin", "La-Todin"] },
      { name: "Zondoma", communes: ["Gourcy", "Boussou", "Léba"] },
      { name: "Loroum", communes: ["Titao", "Ouindigui", "Sollé"] },
    ],
  },
  {
    name: "Plateau-Central",
    provinces: [
      { name: "Oubritenga", communes: ["Ziniaré", "Loumbila", "Nagréongo"] },
      { name: "Ganzourgou", communes: ["Zorgho", "Boudry", "Méguet"] },
      { name: "Kourwéogo", communes: ["Boussé", "Laye", "Niou"] },
    ],
  },
  {
    name: "Sahel",
    provinces: [
      { name: "Séno", communes: ["Dori", "Bani", "Seytenga"] },
      { name: "Soum", communes: ["Djibo", "Aribinda", "Kelbo"] },
      { name: "Oudalan", communes: ["Gorom-Gorom", "Markoye", "Déou"] },
      { name: "Yagha", communes: ["Sebba", "Solhan", "Tankougounadié"] },
    ],
  },
  {
    name: "Sud-Ouest",
    provinces: [
      { name: "Bougouriba", communes: ["Diébougou", "Bondigui", "Tiankoura"] },
      { name: "Ioba", communes: ["Dano", "Zambo", "Ouessa"] },
      { name: "Noumbiel", communes: ["Batié", "Kpuéré", "Midebdo"] },
      { name: "Poni", communes: ["Gaoua", "Bousséra", "Malba"] },
    ],
  },
];

export const TERRITORY_REGION_NAMES = TERRITORY_REGIONS.map((region) => region.name);

// ---------------------------------------------------------------------------
// Aide à la sélection territoriale en cascade
// Région → Province → Commune / Ville → Secteur / Quartier
// ---------------------------------------------------------------------------

export interface TerritorySelection {
  region: string;
  province: string;
  commune: string;
  secteur: string;
}

export const EMPTY_TERRITORY_SELECTION: TerritorySelection = {
  region: "",
  province: "",
  commune: "",
  secteur: "",
};

export function emptyTerritorySelection(): TerritorySelection {
  return { ...EMPTY_TERRITORY_SELECTION };
}

/** Normalise un texte (minuscules, sans accents) pour comparaison. */
export function normaliserTexte(value: string): string {
  return value
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
}

export function getProvinces(region: string): string[] {
  return TERRITORY_REGIONS.find((item) => item.name === region)?.provinces.map((p) => p.name) ?? [];
}

export function getCommunes(region: string, province: string): string[] {
  const found = TERRITORY_REGIONS.find((item) => item.name === region)?.provinces.find(
    (p) => p.name === province
  );
  return found?.communes ?? [];
}

const COMMUNE_INDEX = new Map<string, { region: string; province: string }>();
TERRITORY_REGIONS.forEach((region) => {
  region.provinces.forEach((province) => {
    province.communes.forEach((commune) => {
      const key = normaliserTexte(commune);
      if (!COMMUNE_INDEX.has(key)) COMMUNE_INDEX.set(key, { region: region.name, province: province.name });
    });
  });
});

/** Région déduite d'une commune / ville. Chaîne vide si inconnue. */
export function regionOfCommune(commune: string): string {
  if (!commune) return "";
  return COMMUNE_INDEX.get(normaliserTexte(commune))?.region ?? "";
}

/** Province déduite d'une commune / ville. Chaîne vide si inconnue. */
export function provinceOfCommune(commune: string): string {
  if (!commune) return "";
  return COMMUNE_INDEX.get(normaliserTexte(commune))?.province ?? "";
}

/** Champs territoriaux qu'un enregistrement peut porter. */
export interface TerritoryFields {
  region?: string;
  province?: string;
  commune?: string;
  ville?: string;
  secteur?: string;
}

/**
 * Indique si un enregistrement correspond à la sélection territoriale.
 * Les niveaux non renseignés sur l'enregistrement sont déduits de la commune
 * (ou de la ville), ce qui rend le filtrage utilisable dès aujourd'hui et
 * directement compatible avec de futures colonnes Supabase
 * (region / province / commune / secteur).
 */
export function matchesTerritory(record: TerritoryFields, selection: TerritorySelection): boolean {
  if (!selection.region && !selection.province && !selection.commune && !selection.secteur) return true;

  const communeRaw = record.commune || record.ville || "";
  const commune = normaliserTexte(communeRaw);
  const province = normaliserTexte(record.province || provinceOfCommune(communeRaw));
  const region = normaliserTexte(record.region || regionOfCommune(communeRaw));
  const secteur = normaliserTexte(record.secteur || "");

  if (selection.region && region !== normaliserTexte(selection.region)) return false;
  if (selection.province && province !== normaliserTexte(selection.province)) return false;
  if (selection.commune && commune !== normaliserTexte(selection.commune)) return false;
  if (selection.secteur && secteur !== normaliserTexte(selection.secteur)) return false;
  return true;
}

// ---------------------------------------------------------------------------
// Secteurs / quartiers
// Vocabulaire réel des principales villes. Les communes sans données de secteur
// renvoient une liste vide : on n'invente aucun secteur.
// ---------------------------------------------------------------------------

export const TERRITORY_SECTEURS: Record<string, string[]> = {
  ouagadougou: [
    "Secteur 1",
    "Secteur 2",
    "Secteur 4",
    "Secteur 6",
    "Secteur 15",
    "Secteur 22",
    "Secteur 23",
    "Secteur 29",
    "Secteur 30",
    "Ouaga 2000",
    "Tanghin",
    "Zone du Bois",
    "Dassasgho",
    "Gounghin",
    "Karpala",
  ],
  "bobo-dioulasso": [
    "Secteur 1",
    "Secteur 2",
    "Secteur 4",
    "Secteur 13",
    "Secteur 21",
    "Secteur 22",
    "Secteur 23",
    "Secteur 25",
    "Secteur 29",
    "Secteur 30",
    "Sarafala",
    "Accart-Ville",
    "Dafra",
    "Koko",
  ],
  koudougou: [
    "Secteur 1",
    "Secteur 2",
    "Secteur 3",
    "Secteur 4",
    "Secteur 5",
    "Secteur 6",
    "Secteur 7",
    "Secteur 8",
    "Secteur 9",
    "Secteur 10",
  ],
  banfora: ["Secteur 1", "Secteur 2", "Secteur 3", "Secteur 4", "Secteur 5", "Secteur 6", "Secteur 7"],
  ouahigouya: [
    "Secteur 1",
    "Secteur 2",
    "Secteur 3",
    "Secteur 4",
    "Secteur 5",
    "Secteur 6",
    "Secteur 7",
    "Secteur 8",
    "Secteur 9",
    "Secteur 10",
    "Secteur 11",
    "Secteur 12",
  ],
  kaya: ["Secteur 1", "Secteur 2", "Secteur 3", "Secteur 4", "Secteur 5", "Secteur 6", "Secteur 7"],
  "fada n'gourma": ["Secteur 1", "Secteur 2", "Secteur 3", "Secteur 4", "Secteur 5", "Secteur 6", "Secteur 7"],
  dedougou: ["Secteur 1", "Secteur 2", "Secteur 3", "Secteur 4", "Secteur 5", "Secteur 6", "Secteur 7"],
  tenkodogo: ["Secteur 1", "Secteur 2", "Secteur 3", "Secteur 4", "Secteur 5", "Secteur 6"],
  hounde: ["Secteur 1", "Secteur 2", "Secteur 3", "Secteur 4", "Secteur 5"],
  ziniare: ["Secteur 1", "Secteur 2", "Secteur 3", "Secteur 4", "Secteur 5"],
  manga: ["Secteur 1", "Secteur 2", "Secteur 3", "Secteur 4"],
  dori: ["Secteur 1", "Secteur 2", "Secteur 3", "Secteur 4"],
  gaoua: ["Secteur 1", "Secteur 2", "Secteur 3", "Secteur 4"],
  leo: ["Secteur 1", "Secteur 2", "Secteur 3"],
};

/**
 * Secteurs / quartiers d'une commune, uniquement si la commune appartient bien
 * à la province et à la région fournies (cascade cohérente).
 */
export function getSecteurs(region: string, province: string, commune: string): string[] {
  if (!commune) return [];
  if (region && regionOfCommune(commune) !== region) return [];
  if (province && provinceOfCommune(commune) !== province) return [];
  return TERRITORY_SECTEURS[normaliserTexte(commune)] ?? [];
}